export default "__VITE_ASSET__CmNtdet5__"